// @flow
import RegisterPaymentDetails from './RegisterPaymentDetails';
import {connect} from 'react-redux';
import {deliveryMethodSelector} from '../../../modules/SignUp/DeliveryMethod/selectors';
import {isLoadingSelector} from '../../../modules/LoadingStatus/reducer';
import {isOrderingReplacementSim as orderingReplacementSim} from '../../../lib/navigation';
import {
  refreshPaymentDetailsDuringOrderSim,
  paymentAuthenticationsSelector,
} from '../../../modules/Payment';
import {
  signUpCheckOrderConsistency,
  signUpCheckOrderConsistencyOrderStatusSelector,
} from '../../../modules/SignUp/CheckOrderConsistency';
import {eSimSelectedSelector} from '../../../modules/ESim';

const mapStateToProps = state => {
  const deliveryMethod = deliveryMethodSelector(state);

  return {
    canSkipPayment: !!deliveryMethod && deliveryMethod.price === 0,
    hasUnauthenticatedPayment: !!paymentAuthenticationsSelector(state).length,
    isCheckOrderConsistencyLoading: isLoadingSelector(
      state,
      'signUpCheckOrderConsistencySaga',
    ),
    isConfirmLoading:
      isLoadingSelector(state, 'confirmPlan') ||
      isLoadingSelector(state, 'updateBillingAddressDuringProcess'),
    isOrderingReplacementSim: orderingReplacementSim(),
    isLoading: isLoadingSelector(state, 'refreshPaymentDetails'),
    isOrderOk: signUpCheckOrderConsistencyOrderStatusSelector(state),
    eSimSelected: eSimSelectedSelector(state),
  };
};

const mapDispatchToProps = {
  refreshPaymentDetails: refreshPaymentDetailsDuringOrderSim,
  signUpCheckOrderConsistency,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RegisterPaymentDetails);
